import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ProviderBookingTable from '../components/ProviderBookingTable';

const ProviderDashboard = () => {
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [bookings, setBookings] = useState([]);

  const fetchSummary = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get('/api/provider/dashboard/summary', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSummary(res.data);
    } catch (err) {
      console.error('Failed to load summary:', err);
    } finally {
      setLoading(false);
    }
  };

  const fetchBookings = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get('/api/provider/bookings', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setBookings(res.data.bookings);
    } catch (err) {
      console.error('Failed to load bookings:', err);
    }
  };

  useEffect(() => {
    fetchSummary();
    fetchBookings();
  }, []);

  if (loading) return <div className="p-8 text-gray-500">Loading dashboard...</div>;
  if (!summary) return <div className="p-8 text-red-500">Failed to load data.</div>;

  return (
    <div className="max-w-4xl mx-auto p-6 space-y-6">
      <h1 className="text-3xl font-bold text-gray-800">Provider Dashboard</h1>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div className="bg-white rounded-xl shadow p-4">
          <h2 className="text-gray-500 text-sm">Total Income</h2>
          <p className="text-xl font-bold">${Number(summary.totalIncome || 0).toFixed(2)}</p>
        </div>
        <div className="bg-white rounded-xl shadow p-4">
          <h2 className="text-gray-500 text-sm">Total Bookings</h2>
          <p className="text-xl font-bold">{summary.totalBookings || 0}</p>
        </div>
        <div className="bg-white rounded-xl shadow p-4">
          <h2 className="text-gray-500 text-sm">Utilization</h2>
          <p className="text-xl font-bold">{summary.utilization || 0}%</p>
        </div>
      </div>

      <div className="bg-white rounded-xl shadow p-4 mt-4">
        <h2 className="text-gray-700 font-semibold mb-2">Parking Spaces</h2>
        {summary.spaces.length === 0 ? (
          <p className="text-gray-400">No spaces owned yet.</p>
        ) : (
          <ul className="list-disc list-inside text-gray-600">
            {summary.spaces.map((id) => (
              <li key={id}>Space ID: {id}</li>
            ))}
          </ul>
        )}
      </div>

      {/* ✅ Booking Table Below Summary */}
      <ProviderBookingTable bookings={bookings} />
    </div>
  );
};

export default ProviderDashboard;
